<div class="card p-2 shadow-sm h-100">
    <div class="row g-2">
        <div class="col-md-12 col-lg-3 text-center">
            <img [src]="'https://assets.digiamerica.us/images/products/' + product.type + '/' + product.sku + '.webp'"
                [alt]="product.name" class="img-fluid product-image" />
        </div>
        <!-- Product Details -->
        <div class="col-md-6 col-lg-4">

            <!-- Product Title / Name / SKU -->
            <h5 class="fw-bold mb-2">{{product.name}}</h5>
            <p class="text-muted mb-1">SKU: {{product.sku}}</p>
            @if (product.minimumOrderQuantity > 1) {
            <p class="mb-1"><span class="badge bg-warning text-dark">Min. Order: {{product.minimumOrderQuantity}}</span></p>
            }


            <!-- Three different prices -->
            <div class="mb-3">
                @if (product.listPrice) {
                <p class="mb-1">
                    <strong>List Price:</strong> {{product.listPrice | currency}}
                    @let prices = product.listPrices;
                    @if (prices) {
                <ul>
                    @for (priceCode of prices; track priceCode.code) {
                    @if(priceCode.code !== "BASE") {
                    <li>{{priceCode.price | currency}} {{priceCode.code}}</li>
                    }
                    }
                </ul>
                }
                </p>
                }
                @if (product.dealerPrice) {
                <p class="mb-1">
                    <strong>Dealer Price:</strong> {{product.dealerPrice | currency}}
                    @let prices = product.dealerPrices;
                    @if (prices) {
                <ul>
                    @for (priceCode of prices; track priceCode.code) {
                    @if(priceCode.code !== "BASE") {
                    <li>{{priceCode.price | currency}} {{priceCode.code}}</li>
                    }
                    }
                </ul>
                }
                </p>
                }
                @if (product.directPrice) {
                <p class="mb-1">
                    <strong>Direct Price:</strong> {{product.directPrice | currency}}
                    @let prices = product.directPrices;
                    @if (prices) {
                <ul>
                    @for (priceCode of prices; track priceCode.code) {
                    @if(priceCode.code !== "BASE") {
                    <li>{{priceCode.price | currency}} {{priceCode.code}}</li>
                    }
                    }
                </ul>
                }
                </p>
                }
            </div>

            <p class="card-text" style="white-space: pre;">{{product.description}}</p>

            @if (product.memo) {
            <p class="card-text text-danger">
                {{product.memo}}
            </p>
            }

        </div>

        <div class="col-md-6 col-lg-3">
            @if (!product.active) {
            <h3 class="text-danger">Disabled</h3>
            }
            <!-- Text attributes (bulleted list) -->
            <ul class="list-bullet mb-3">
                @for (key of objectKeys(product.additionalAttributes); track key) {
                @if(product.additionalAttributes[key].value) {
                <li>
                    <strong>{{product.additionalAttributes[key].label}}</strong>
                    {{product.additionalAttributes[key].value}}
                </li>
                }
                }
            </ul>
        </div>

        <!-- Action Buttons -->
        <div class="col-lg-6 offset-lg-3">
            @if(quoteId !== undefined)
            {
            <button class="btn btn-primary me-2 mb-2" (click)="addProductToQuote(quoteId, product)">
                <i class="bi bi-cart-fill me-1"></i> Add to Quote
            </button>
            }
            @if(false)
            {
            <button class="btn btn-outline-secondary mb-2">
                <i class="bi bi-eye me-1"></i> View Details
            </button>
            }
            @if(hasUpdatePermissions()) {
            <a [routerLink]="['/', 'product-update', product.id]" class="btn btn-outline-secondary m-2">Modify</a>

            }

            @if(hasPricePermissions()) {
            <a [routerLink]="['/', 'product-price', product.id]" class="btn btn-outline-secondary m-2">
                Pricing
            </a>
            }

            <span class="float-end">
                <button class="btn btn-sm btn-outline-info" (click)="launchFeedback(product)"><fa-icon
                        [icon]="feedbackIcon"></fa-icon> Feedback</button>
            </span>
        </div>
    </div>

</div>